import React, { useContext, useState } from "react";
import Navbar from "../components/Navbar";
import { useNavigate, Link } from "react-router-dom";
import data from "../language.json";
import languageContext from "../context/language/languageContext";
import axios from "axios";

const Login = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const { lang, phone, setPhone } = useContext(languageContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (phone.length !== 10) {
      alert("Please enter a valid 10-digit number");
      return;
    }

    const headerList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    try {
      setLoader(true);
      const response = await axios.post(
        "https://www.careplus.gopillz.com/parent_send_otp",
        JSON.stringify({ phone }),
        { headers: headerList }
      );
        // setResponseMessage(response.data.message || data[lang]["auth"][5]);
        navigate("/otp", { state: { from: "signup" } });
          
    } catch (error) {
      console.error("Error sending OTP:", error.response?.data || error.message);
      setResponseMessage(
        error.response?.data?.msg || data[lang]["auth"][7]
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="w-full flex flex-col items-center justify-start text-center font-bold bg-gray-100 h-screen pt-16">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-700">{data[lang]["auth"][4]}</h1>
          <p className="text-sm font-normal text-gray-500 mt-1">
            {data[lang]["auth"][8]}
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-xl px-6 py-5 sm:w-[90%] md:w-[50%] lg:w-[28%]">
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="text-left">
              <label className="text-[15px] text-gray-700 font-medium">
                {data[lang]["auth"][9]}
              </label>
              <input
                type="text"
                required
                maxLength="10"
                className="w-full px-4 py-2 border rounded-lg bg-gray-100 my-1 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 transition-all text-sm"
                placeholder={data[lang]["auth"][10]}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-all text-sm"
            >
              {loader ? (
                <div className="animate-spin h-4 w-4 border-t-2 border-white border-solid mx-auto"></div>
              ) : (
                <span>{data[lang]["auth"][11]}</span>
              )}
            </button>
            {responseMessage && (
              <div className="text-green-500 mt-2 text-sm">{responseMessage}</div>
            )}
          </form>

          {/* <div className="mt-4 text-[13px] text-gray-600">
            {data[lang]["auth"][12]} {" "}
            <Link to="/student-login" className="text-blue-500 hover:underline">
              {data[lang]["auth"][13]}
            </Link>` 
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
